import React from 'react';
import { Link, useLocation } from "react-router-dom";
import { FaTruck } from "react-icons/fa";


let CourierCompaniesList = () => {
    return (
        <>

<div className="container mt-5">
      <div className="dropdown">
        <span
          className="dropdown-toggle"
          type="button" style={{color:'white'}}
          data-bs-toggle="dropdown"
        >
          Courier Companies
        </span>

        <ul className="dropdown-menu">
          <li>
            <Link to="/a" className="dropdown-item">
                Company A
            </Link>
            <Link to="/b" className="dropdown-item">
                Company B
            </Link>
          </li>
          
        </ul>
      </div>
    </div>

        </>
    );
}


export default CourierCompaniesList;